import { render, staticRenderFns } from "./UpperTop.vue?vue&type=template&id=2df50348&"
import script from "./UpperTop.vue?vue&type=script&lang=js&"
export * from "./UpperTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports